import request from '@/utils/request'
import apiConfig from '@/api/apiconfig'
// 发送验证码
// bizType  固定值为goddess 女神节
export function girlSendCaptcha(data, bizType = 'goddess') {
  return request({
    url: `${apiConfig.ZY}/ydAct/${bizType}/sendCaptcha`,
    method: 'post',
    data
  })
}
// 登录
export function girlLogin(data, bizType = 'goddess') {
  return request({
    url: `${apiConfig.ZY}/ydAct/${bizType}/login`,
    method: 'post',
    data
  })
}
// 领取
export function girlReceive(data, bizType = 'goddess') {
  return request({
    url: `${apiConfig.ZY}/ydAct/${bizType}/receive`,
    method: 'post',
    token: sessionStorage.getItem('ydGrilsDayToken'),
    hideErrorToast: true,
    data
  })
}
// 详情
export function girlReceiveOrder(data, bizType = 'goddess') {
  return request({
    url: `${apiConfig.ZY}/ydAct/${bizType}/getReceiveOrder`,
    method: 'post',
    token: sessionStorage.getItem('ydGrilsDayToken'),
    data
  })
}
